import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";

const Graph = ({ tasksViewMode }) => {
  const [chartData, setChartData] = useState({
    categories: [],
    completed: [],
    added: [],
  });

  useEffect(() => {
    fetchTasks();
  }, [tasksViewMode]);

  const getDateRange = () => {
    const today = new Date();
    let dates = [];

    switch (tasksViewMode) {
      case "daily":
        for (let i = 6; i >= 0; i--) {
          const d = new Date();
          d.setDate(today.getDate() - i);
          dates.push(d.toISOString().split("T")[0]);
        }
        break;

      case "monthly":
        for (let i = 29; i >= 0; i--) {
          const d = new Date();
          d.setDate(today.getDate() - i);
          dates.push(d.toISOString().split("T")[0]);
        }
        break;

      case "sixMonths":
      case "yearly":
        for (let i = 11; i >= 0; i--) {
          const d = new Date();
          d.setMonth(today.getMonth() - i);
          dates.push(`${d.getFullYear()}-${d.getMonth() + 1}`);
        }
        break;

      default:
        dates.push(today.toISOString().split("T")[0]);
    }

    return dates;
  };

  const fetchTasks = async () => {
    try {
      const response = await fetch("https://backend.sanchalansetu.com/api/v1/get-data-list", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch tasks");

      const result = await response.json();
      const allTasks = result.alltask || [];

      const categories = getDateRange();
      const added = Array(categories.length).fill(0);
      const completed = Array(categories.length).fill(0);

      allTasks.forEach((t) => {
        const taskDate = new Date(t.created_at || t.createdAt);
        let key;

        switch (tasksViewMode) {
          case "daily":
          case "monthly":
            key = taskDate.toISOString().split("T")[0];
            break;
          case "sixMonths":
          case "yearly":
            key = `${taskDate.getFullYear()}-${taskDate.getMonth() + 1}`;
            break;
          default:
            key = taskDate.toISOString().split("T")[0];
        }

        const index = categories.indexOf(key);
        if (index !== -1) {
          added[index] += 1;
          if (t.status === 1) completed[index] += 1;
        }
      });

      setChartData({ categories, added, completed });
    } catch (err) {
      console.error("Error fetching tasks:", err);
    }
  };

  const chartOptions = {
    chart: { height: 300, type: "line", zoom: { enabled: false }, toolbar: { show: false } },
    stroke: { width: [3, 3], curve: "smooth" },
    colors: ["#28a745", "#ffc107"],
    xaxis: { categories: chartData.categories },
    legend: { position: "top", horizontalAlign: "right" },
    tooltip: { shared: true },
  };

  const series = [
    { name: "Tasks Completed", data: chartData.completed },
    { name: "Tasks Assigned", data: chartData.added },
  ];

  return <Chart options={chartOptions} series={series} type="line" height={300} />;
};

export default Graph;
